export const Sachkontenzuordnung = [
  {
    'PAISY-Wert': 1,
    Bezeichnung: 'Lehrkräfte',
  },
  {
    'PAISY-Wert': 2,
    Bezeichnung: 'Verwaltung, Sekretariat',
  },
  {
    'PAISY-Wert': 3,
    Bezeichnung: 'Technische Mitarbeiter',
  },
  {
    'PAISY-Wert': 4,
    Bezeichnung: 'Betreuungskräfte',
  },
  {
    'PAISY-Wert': 5,
    Bezeichnung: 'Beamte',
  },
];
